import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import LazyImage from '../components/LazyImage';
import CustomDot from './CustomDots';
import { MediaType, ProductMedia } from '../interface/interface';
import { Dispatch, SetStateAction } from 'react';

export default function ProductCarousel({
  media,
  setImageUrl,
  setOpen,
}: Readonly<{
  media: ProductMedia[];
  setImageUrl: Dispatch<SetStateAction<string>>;
  setOpen: Dispatch<SetStateAction<boolean>>;
}>) {
  const renderItem = (m: ProductMedia) => {
    if (m.type === MediaType.IMAGE) {
      return (
        <LazyImage
          url={m.url}
          alt="product_image"
          className="w-8/12 2xl:w-full h-80 md:h-72 lg:h-96 object-contain mx-auto"
          setOpen={setOpen}
          setImageUrl={setImageUrl}
        />
      );
    }

    return (
      <div className="h-72 md:h-96 md:w-[400px] w-auto mx-auto flex justify-center items-center">
        <video
          controls
          poster={m.thumbnail}
          className="w-full h-full object-contain"
        >
          <source src={m.url} type="video/mp4" />
          <track
            src={m?.captionsUrl || 'captions.vtt'}
            kind="captions"
            srcLang="en"
            label="English"
            default
          />
        </video>
      </div>
    );
  };

  if (!media?.length) return null;

  if (media.length === 1) {
    return <div className="w-full h-full relative">{renderItem(media[0])}</div>;
  }

  return (
    <Carousel
      additionalTransfrom={0}
      arrows={true}
      autoPlaySpeed={3000}
      centerMode={false}
      renderArrowsWhenDisabled={false}
      renderButtonGroupOutside={false}
      removeArrowOnDeviceType={['desktop', 'mobile', 'tablet']}
      responsive={{
        desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
        mobile: { breakpoint: { max: 464, min: 0 }, items: 1 },
        tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
      }}
      showDots={true}
      dotListClass="md:flex md:flex-col md:justify-start md:gap-2 md:absolute md:left-0 md:top-0 md:h-full md:overflow-y-auto md:w-16 w-auto overflow-x-auto"
      containerClass="w-full h-full relative"
      customDot={<CustomDot urls={media.map((x) => x.thumbnail)} />}
    >
      {media.map((m) => (
        <div key={m.url}>{renderItem(m)}</div>
      ))}
    </Carousel>
  );
}
